import { TableDateColumnFilter } from "./TableDateColumnFilter.js";
import { IconCalendar } from "@synthesis/shared-icons";
import { jsx } from "react/jsx-runtime";
import dayjs from "dayjs";
//#region src/TableDateColumnFilter/TableDateColumnFilter.lib.tsx
const defaultFiltersLineValueFormatter = (filter) => `с ${dayjs.unix(filter.start ?? 0).format("DD.MM.YYYY")} по ${dayjs.unix(filter.end ?? 0).format("DD.MM.YYYY")}`;
const getTableColumnDateFilter = ({ withTime, filtersLineIcon = /* @__PURE__ */ jsx(IconCalendar, { className: "size-5" }), columnFormat, filtersLineValueFormatter = defaultFiltersLineValueFormatter, otherFilterParams, valuePlaceholder } = {}) => {
	return {
		valueFormatter: columnFormat ? ({ value }) => {
			if (!value) return valuePlaceholder ?? "";
			const date = typeof value === "number" ? dayjs.unix(value) : dayjs(value);
			return date.isValid() ? date.format(columnFormat) : String(value);
		} : void 0,
		filter: TableDateColumnFilter,
		filterParams: {
			withTime,
			filtersLineIcon,
			filtersLineValueFormatter,
			comparator: (model, item) => {
				if (model?.start == null || model?.end == null) return true;
				if (item == null || item === "" || item === "—") return false;
				const date = typeof item === "number" ? dayjs.unix(item) : dayjs(item);
				if (!date.isValid()) return false;
				const unix = date.unix();
				return unix >= model.start && unix <= model.end;
			},
			...otherFilterParams
		}
	};
};
const isDateTableFilter = (item) => Boolean(typeof item === "object" && item && "start" in item && "end" in item);
//#endregion
export { getTableColumnDateFilter, isDateTableFilter };

//# sourceMappingURL=TableDateColumnFilter.lib.js.map